export class Account {
  id = 0;
  label: string;
  logo: string;
  public_upload: string;
  public_download: string;
  show_tos: string;
  ack_tos: string;
  tos_prompt: string;
  tos_message: string;
  back_link: string;
  toggle_link = 'Y';
  active: string;
  customisable_settings: object = {};
  payload_parsed: object = {};
  calendars: object[] = [];
}
